import {
  take,
  put,
  fork,
  cancel,
  select,
  cancelled,
  actionChannel,
} from "redux-saga/effects"

import devlog from "src/helpers/devlog"
import { request } from "src/engine/modules/session/effects"
import isFunction from "lodash/isFunction"
import { showToast } from "@infotech/uikit-toasts"
import get from "lodash/get"
import getWordByModelName from "src/helpers/text/getWordByModelName"
import { normalize as normalizeModel } from "src/engine/modules/model/helpers"
import { requestValidate } from "src/engine/modules/validate/actions/creators"
import getWordEnding from "../helpers/getWordEnding"
import { process as selectProcess } from "../selectors"
import { types, creators } from "../actions"
import { normalize } from "../helpers"

const METHOD = `post`

function* create(action) {
  const { id, model, data, callback } = action
  const name = get(data, `name`)

  try {
    const { getUrl, getRestUrn } = normalizeModel(model)

    const requestURL = getRestUrn ? getRestUrn(METHOD) : getUrl() // TODO: remove getUrl support

    const denormalizedData = isFunction(model.denormalize)
      ? model.denormalize(data, {
          method: METHOD,
        })
      : data

    const { data: nextData } = yield request(
      requestURL,
      {},
      {
        method: METHOD,
        body: denormalizedData,
      },
    )
    const normalized = normalize(nextData, model)
    yield put(creators.read.success(model, normalized.id, normalized.data))
    yield put(creators.create.success(model, id, normalized.id))
    if (get(data, `withValidate`)) {
      yield put(requestValidate({ plan: data.planId }))
    }
    showToast({
      type: `success`,
      message: `${getWordByModelName(model.name, false, true)} ${
        name ? `"${name}" ` : ``
      }успешно создан${getWordEnding(model.name)}.`,
      hideIn: 5,
    })
    if (callback && typeof callback === `function`) {
      callback(nextData)
    }
  } catch (error) {
    devlog(error)
    yield put(creators.create.error(model, id, error))
    if (model.name === `events`) {
      showToast({
        type: `error`,
        message: error.data.exception || `Unknown error`,
        hideIn: 5,
      })
    }
  } finally {
    if (yield cancelled()) {
      yield put(creators.create.cancel(model, id))
    }
  }
}

export default function* createSaga() {
  const createRequests = yield actionChannel([types.create, types.createCancel])
  while (true) {
    const action = yield take(createRequests)

    const { id, model } = action

    const process = yield select(selectProcess, model, id)

    if (action.type === types.create) {
      // Detect current action is works

      if (process) {
        switch (process.type) {
          // Drop error, if it's do something, another of creating
          case types.read:
          case types.update:
            throw new Error(`Illegal action type of current process`)
          // Ignore this action, because another creating is already running
          // And perhaps it has already reached the server, so breaking previous
          // action will crush server logic
          case types.create:
            return
          // Drop error if it's removing
          case types.remove:
            throw new Error(
              `You can not create entity, that is in the process of removing`,
            )
          default:
            throw new Error(`Unknown entity action type founded`)
        }
      }
      const task = yield fork(create, action)
      yield put(creators.processing.start(types.create, task, model, id))
      yield fork(function* watchFork() {
        yield put(creators.processing.complete(types.create, task, model, id))
      })
      // If fetch completed, we should erase existen progress
    } else if (action.type === types.createCancel) {
      if (process) {
        const { task } = process
        if (process.type === types.create) {
          yield cancel(task)
        } else {
          throw new Error(
            `Unexpected cancellation of process with another task`,
          )
        }
      }
    }
  }
}
